import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import line from "../assets/Line.png";
import initial from "../assets/initial.png";
import alarm from "../assets/alarm.png";
import "../pages/GoXDashboard/GoXDashboard.css";
import searchIcon from "../assets/searchIcon.png";
import add from "../assets/add.png";
import text from "../assets/text.png";
import all from "../assets/all.png";
import active from "../assets/active.png";
import inactive from "../assets/inactive.png";
import pending from "../assets/pending.png";
import Line from "../assets/Line.png";
import menu from "../assets/menu.png";
import { CiSearch } from "react-icons/ci";
import {FaBell} from 'react-icons/fa'
import Button from 'react-bootstrap/Button';

import "./EmployeeFolder/EmployeeFolder.css";
import Table from "./Table";
import Employeeconnect from "../pages/Invite/Employeeconnect";
import Invitesent from "../pages/Invite/Invitesent";
import Sendinvite from "../pages/Invite/Sendinvite";
import { signin } from "../action/user";
import Table2 from "./SalaryTable";
import { listEmployees } from "../action/listemploy";
import { useDispatch, useSelector } from "react-redux";
import { dashuser } from "../action/dashbuser";
import EmployeeFolder from "./EmployeeFolder/EmployeeFolder";
function Employee() {
  const [showDiv, setShowDiv] = useState(false);
  const [tab, setTab] = useState("");
  const [showOption, setShowOption] = useState(false);
  const [mode, setMode] = useState("");
  const [option, setOption] = useState("option1");
  const isEmpty = true;
  const [modalShow, setModalShow] = useState(false);

  const toggleDiv = () => {
    setShowDiv(!showDiv);
  };

  const dispatch = useDispatch();
  const employees = useSelector((state) => state?.list);
  useEffect(() => {
    dispatch(listEmployees());
    dispatch(dashuser());
  }, []);

  const user = useSelector((state)=> state?.dashuser)

  console.log(user?.dashuser?.data)
  useEffect(() => {
    // dispatch(listEmployees())

    console.log('called')
    dispatch(dashuser())
  }, [])
  console.log(user?.dashuser?.data?.first_name)

  return (
    <>
      <div className="icon " onClick={toggleDiv}>
        <img src={menu} alt="" />
      </div>
      {showDiv && (
        <div className=" your-div1">
          {/* <div className="employ mt-5 d-flex justify-content-between">
            <div className="d-flex ">
              <div className="emp"> Employee</div>
              <div className="mx-3 zero d-flex justify-content-center align-items-center">
                0
              </div>
            </div>

            <div className="d-flex ini ">
              <div className="mx-2">
                <img src={alarm} alt="" />
              </div>
              <div className="mx-2">
                <img src={line} alt="" />
              </div>
              
            </div>
          </div> */}

<div className='header'>
        <h1 className='header-h1'>Employee</h1>
        <div className='header-tool'>
          {/* <img src="/notification.png" alt="notification icoc" className='icon'/> */}
          <FaBell className='icon'/>
          
          <div className='header-name-div'>
            <h1 className='header-name'>{user?.dashuser?.data?.first_name.slice(0, 1) +  user?.dashuser?.data?.last_name.slice(0, 1)}</h1>
            </div>
        </div>
      </div>

          <div className="d-flex mx-3 mt-2 activities">
            <div className="allemploy d-flex m-3">
              <div>
                <img src={all} alt="" />
              </div>
              <div className="mt-2 mx-2">
                <h6>All employees</h6>
                <p>
                  <strong>144</strong>
                </p>
              </div>
              <div className="mx-3">
                <img src={Line} alt="" />
              </div>
            </div>
            <div className="activeemploy d-flex m-3">
              <div>
                <img src={active} alt="" />
              </div>
              <div className="mt-2 mx-2">
                <h6>Active Employees</h6>
                <p>
                  <strong>134</strong>
                </p>
              </div>
              <div className="mx-3">
                <img src={Line} alt="" />
              </div>
            </div>
            <div className="inactiveemploy d-flex m-3">
              <div>
                <img src={inactive} alt="" />
              </div>
              <div className="mt-2 mx-2">
                <h6>Inactive Employees</h6>
                <p>
                  <strong>10</strong>
                </p>
              </div>
              <div className="mx-3">
                <img src={Line} alt="" />
              </div>
            </div>
            <div className="pendingactivation d-flex m-3 ">
              <div>
                <img src={pending} alt="" />
              </div>
              <div className="mt-2 mx-2">
                <h6>Pending employees</h6>
                <p>
                  <strong>0</strong>
                </p>
              </div>
            </div>
          </div>

          <div className="container mt-3">
            <div className="row justify-content-between">
              <div className="col-md-5">
                <div className="input-group">
                  <span className="input-group-text">
                    <img src={searchIcon} alt="" />
                  </span>
                  <input type="text" className="search" placeholder="Search" />
                </div>
              </div>

              <div className="col-md-5">
                <button
                  onClick={() => setShowOption(true)}
                  className="btn  btn-block btn3"
                >
                  {" "}
                  <span>
                    <img src={add} alt="" />
                  </span>
                  Add Employee
                </button>
                <Button className='modal-button' 
                onClick={() => setShowOption(true)}
                 
                >
                  {" "}
                  <span>
                    <img src={add} alt="" />
                  </span>
                  Add Employee
           
          </Button>

          <Employeeconnect show={modalShow} onHide={() => setModalShow(false)} />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="your-div your-div2">
        <div className="employ mt-5 d-flex justify-content-between">
          <div className="d-flex ">
            <div className="emp"> Employee</div>
            <div className="mx-3 zero d-flex justify-content-center align-items-center">
              0
            </div>
          </div>

          <div className="d-flex ini ">
            <div className="mx-2">
              <img src={alarm} alt="" />
            </div>
            <div className="mx-2">
              <img src={line} alt="" />
            </div>
            <div>
            <h1 className='header-name'>{user?.dashuser?.data?.first_name.slice(0, 1) +  user?.dashuser?.data?.last_name.slice(0, 1)}</h1>
            </div>
          </div>
        </div>

        <div className="d-flex mx-3 mt-2 activities">
          <div className="allemploy d-flex m-3">
            <div>
              <img src={all} alt="" />
            </div>
            <div className="mt-2 mx-2">
              <h6>All employees</h6>
              <p>
                <strong>144</strong>
              </p>
            </div>
            <div className="mx-3">
              <img src={Line} alt="" />
            </div>
          </div>
          <div className="activeemploy d-flex m-3">
            <div>
              <img src={active} alt="" />
            </div>
            <div className="mt-2 mx-2">
              <h6>Active Employees</h6>
              <p>
                <strong>134</strong>
              </p>
            </div>
            <div className="mx-3">
              <img src={Line} alt="" />
            </div>
          </div>
          <div className="inactiveemploy d-flex m-3">
            <div>
              <img src={inactive} alt="" />
            </div>
            <div className="mt-2 mx-2">
              <h6>Inactive Employees</h6>
              <p>
                <strong>10</strong>
              </p>
            </div>
            <div className="mx-3">
              <img src={Line} alt="" />
            </div>
          </div>
          <div className="pendingactivation d-flex m-3 ">
            <div>
              <img src={pending} alt="" />
            </div>
            <div className="mt-2 mx-2">
              <h6>Pending employees</h6>
              <p>
                <strong>0</strong>
              </p>
            </div>
          </div>
        </div>

        {/* <div className="container mt-3">
      <div className="row justify-content-between">
        <div className="col-md-5">
          <div className="input-group">
            
            <span className="input-group-text">
               <img src={searchIcon} alt="" />
              </span>
            <input
              type="text"
              className="search"
              placeholder="Search"
            />
          </div>
        </div>
          
        <div className='d-flex'>
        <button>Export</button>
          <button>Filter</button>
        </div>

        <div className="col-md-5">
          
          <button className="btn  btn-block btn3"> <span><img src={add} alt="" /></span>Add Employee</button>
        </div>
      </div>
    </div> */}

        <div className="d-flex suspensions">
          <div className="suspensions">
            <h1
              onClick={() => setTab("employees")}
              className={tab === "employees" && "employee-tab-active"}
            >
              Employee
            </h1>
          </div>
          <div className="mx-5">
            <h1
              onClick={() => setTab("salaries")}
              className={tab === "salaries" && "employee-tab-active"}
            >
              Salaries
            </h1>
          </div>
          <div>
            <h1
              onClick={() => setTab("suspensions")}
              className={tab === "suspensions" && "employee-tab-active"}
            >
              Suspensions
            </h1>
          </div>
        </div>

        <div className="employee-function-bar">
          <div>
            <CiSearch className="search-icon" />
            <input placeholder="Search" className="input" />
          </div>

          <div className="employee-button-div">
            <button className="outline-button">Export</button>
            <button className="outline-button">Filter</button>
            <Button className='modal-button' onClick={() => setModalShow(true)}>
            + Add Employee
          </Button>

          <Employeeconnect show={modalShow} onHide={() => setModalShow(false)} />
          </div>
        </div>
      </div>

      {tab === "employees" ? (
        <Table />
      ) : tab === "salaries" ? (
        <Table2 />
      ) : tab === "suspensions" ? (
        <div>suspensions</div>
      ) : (
        <div className="center">
          <div className="small">
            <div className="text ">
              <img src={text} alt="" />
            </div>
            <div className="m-4 details">
              <h6>You currently do not have any details added</h6>
              <p>Tap the button below to add and manage employee details</p>
            </div>
            <div>
            <Button className='modal-button' onClick={() => setModalShow(true)}>
            + Add Employee
          </Button>

           <Employeeconnect show={modalShow} onHide={() => setModalShow(false)} />
            </div>
          </div>
        </div>
      )}

      {showOption ? (
        <div className="position-absolute d-flex top-0 start-0 w-100 h-100 justify-content-center  align-items-center">
          {option === "option1" ? (
            <div>
              <Employeeconnect setMode={setMode} setOption={setOption} />
            </div>
          ) : mode && option === "option2" ? (
            <Sendinvite setOption={setOption} setShowOption={setShowOption} />
          ) : option === "option3" ? (
            <div>
              {mode ? (
                <div>
                  <Invitesent
                    setShowOption={setShowOption}
                    setOption={setOption}
                  />
                </div>
              ) : (
                <div>
                  <Sendinvite setShowOption={setShowOption} />
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Employee;
